import PaymentDetailsPanel from './PaymentDetailsPanel'
export default PaymentDetailsPanel